import React, { useEffect, useState } from 'react';
import { listMyReports, type MyReport } from '../../api/supportReports';

const LABELS: Record<MyReport['status'], string> = {
  new: 'Received', triaged: 'Looking into it', fixed: 'Fixed', closed: 'Closed',
};

export function MyReportsList({ reports }: { reports: MyReport[] }) {
  if (!reports.length) return null;
  return (
    <div className="my-reports">
      <h2>Your reports</h2>
      <ul>
        {reports.map((report) => (
          <li key={report.receipt_ref}>
            #{report.receipt_ref} · {report.product_area} · <strong>{LABELS[report.status] ?? report.status}</strong>
            {report.status_note ? <> — {report.status_note}</> : null}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function MyReports() {
  const [reports, setReports] = useState<MyReport[]>([]);
  useEffect(() => {
    let active = true;
    listMyReports().then((rows) => active && setReports(rows)).catch(() => undefined);
    return () => { active = false; };
  }, []);
  return <MyReportsList reports={reports} />;
}
